/* Liquid-chrome orb mark — one design at every size: hero placements render the full-res
   orb with the breathing pulse; small contexts render the same orb (256px downscale), static. */
export function OrbMark({ size = 64, animated = false, className = "" }) {
  return (
    <div className={`relative rounded-full overflow-hidden ${animated ? "orb-breathe" : ""} ${className}`}
      style={{ width: size, height: size }} data-testid="orb-mark" aria-hidden="true">
      <img src={size >= 96 ? "/orb-hero.jpg" : "/orb-256.jpg"} alt="" width={size} height={size}
        className="w-full h-full object-cover mix-blend-screen" draggable="false" />
    </div>
  );
}

export function BrandWordmark({ size = 30, dark = true, sub = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-wordmark">
      <OrbMark size={size} />
      <span className="flex flex-col">
        <span className={`brand-word leading-none ${dark ? "text-white" : "text-foreground"}`} style={{ fontSize: size * 0.78 }}>
          MISE
        </span>
        {sub && (
          <span className={`mt-1 text-[10px] font-medium uppercase tracking-[0.28em] ${dark ? "text-[#BDB8CC]" : "text-muted-foreground"}`} data-testid="brand-tagline">
            Prepared Intelligence
          </span>
        )}
      </span>
    </div>
  );
}

/* Initials avatar circle (MISE Shift staff picker) — purple gradient, no photos */
export function InitialAvatar({ firstName = "", lastName = "", size = 96 }) {
  const initials = `${firstName[0] || ""}${lastName[0] || ""}`.toUpperCase();
  return (
    <div className="rounded-full flex items-center justify-center border border-[#9D5CFF]/30 font-bold text-[#D4B3FF]"
      style={{
        width: size, height: size, fontSize: size * 0.32,
        background: "linear-gradient(135deg, #231D40 0%, #0B0914 100%)",
        boxShadow: "inset 0 2px 10px rgba(157,92,255,0.12)",
      }}>
      <span className="drop-shadow-md">{initials}</span>
    </div>
  );
}
